import { CustomerSearchPage } from '@/features/customers/routes/CustomerSearchPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers/$filter/')({
  component: CustomerSearchPage,
});
